export const SAVE_SIGNUPCOMPCREATE_DATA = "SAVE_SIGNUPCOMPCREATE_DATA";
export const SAVED_SIGNUPCOMPCREATE_DATA_BY_EMAIL = "SAVED_SIGNUPCOMPCREATE_DATA_BY_EMAIL";
export const SAVED_SIGNUPCOMPCREATE_DATA = "SAVED_SIGNUPCOMPCREATE_DATA";
export const FETCHOTPATMAILID = "FETCHOTPATMAILID"
export const FETCHEDOTPATMAILID = "FETCHEDOTPATMAILID"
export const VALIDATINGPASSWORD = "VALIDATINGPASSWORD"
export const VALIDATEDPASSWORD = "VALIDATEDPASSWORD"
export const VALIDATINGOTP = "VALIDATINGOTP"
export const VALIDATEDOTP = "VALIDATEDOTP"
export const FINALDOMAINCREATION = "FINALDOMAINCREATION"
export const FINALDOMAINCREATIONSTATUS = "FINALDOMAINCREATIONSTATUS"
export const CHECKINGIFDATASAVED = "CHECKINGIFDATASAVED"
export const CHECKEDIFDATASAVED = "CHECKEDIFDATASAVED"